import { TYPES } from '../../common/constants';
import * as client from '../../services/client';

const fetchTypeaheadResultsDone = payload => ({
  type: TYPES.FETCH_TYPEAHEAD_RESULTS_DONE,
  payload,
});

// export const fetchTypeaheadResults = value => dispatch => {
//   return Promise.all([
//     dispatch({
//       type: TYPES.FETCH_TYPEAHEAD_RESULTS,
//       value,
//     }),
//     value ? client.getTypeaheadResults(value)
//       .then(
//         response => dispatch(fetchTypeaheadResultsDone(response.data)),
//         console.log
//       ) : null,
//   ]); 
// };

export const fetchTypeaheadResults = (id,role,value) => dispatch => {
  return Promise.all([
    dispatch({
      type: TYPES.FETCH_TYPEAHEAD_RESULTS,
      value,
    }),
    value && value.trim() ? client.getTypeaheadResults(id,role,value)
      .then(
        response => {
          if(response.status === 200 || response.ok){
            
            response.json().then( 
              responsejson =>{
               
                 dispatch(fetchTypeaheadResultsDone(responsejson)) 
                })
          }
          
        },
      ) : null,
  ]); 
};


export const clearGlobalSearch = () => ({
  type:TYPES.CLEAR_GLOBAL_SEARCH,
 })

